class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", this.onVariantChange);

    /*
     * IMPORTANT FIX:
     * Page first time open hone par bhi selected variant ka
     * actual inventory status check hoga.
     */
    requestAnimationFrame(() => {
      this.initializeVariantState();
    });
  }

  initializeVariantState() {
    try {
      this.updateOptions();
      this.updateOptionsParent();
      this.updateMasterId();
      this.getPreOrderVariantData();

      if (!this.currentVariant) {
        this.toggleAddButton(true, window.variantStrings?.unavailable || "UNAVAILABLE");
        return;
      }

      this.updateVariantInput();
      this.updatePurchaseState();
      this.updatePickupAvailability();
      this.updateContent();
      this.updateVariantStatuses();
    } catch (error) {
      console.error("Variant initialization error:", error);
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();

    this.getPreOrderVariantData();

    this.toggleAddButton(true, "", false);

    this.updatePickupAvailability();
    this.updateContent();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();

      /*
       * IMPORTANT FIX:
       * Variant change hote hi actual qty/policy check.
       */
      this.updatePurchaseState();

      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(
      this.querySelectorAll(".product-form__input--dropdown")
    ).forEach((select, index) => {
      if (
        select.children[0] &&
        select.children[0].children[1]
      ) {
        select.children[0].children[1].innerHTML =
          this.options[index];
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );

    if (!mediaGallery) return;

    if (typeof mediaGallery.setActiveMedia === "function") {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    }
  }

  updateContent() {
    const variant = this.currentVariant;
    const variantID = this.currentVariant?.id ?? null;

    const notifyMeAvailableWrapperList =
      document.querySelectorAll(
        `.notify__me--available-${this.dataset.section}`
      );

    if (!notifyMeAvailableWrapperList.length) return;

    const purchaseState = this.getPurchaseState();

    notifyMeAvailableWrapperList.forEach(
      (notifyMeAvailableWrapper) => {
        if (
          variantID !== null &&
          purchaseState.soldOut
        ) {
          const soldOutProductURL =
            document.querySelector(".soldout__product_url");

          if (soldOutProductURL) {
            soldOutProductURL.value =
              `${this.dataset.origin}${this.dataset.url}` +
              `?variant=${this.currentVariant.id}`;
          }

          notifyMeAvailableWrapper.classList.remove(
            "no-js-inline"
          );
        } else {
          notifyMeAvailableWrapper.classList.add(
            "no-js-inline"
          );
        }
      }
    );
  }

  updateURL() {
    if (
      !this.currentVariant ||
      this.dataset.updateUrl === "false"
    ) {
      return;
    }

    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) return;

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input =
        productForm.querySelector('input[name="id"]');

      if (!input) return;

      input.value = this.currentVariant.id;

      input.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    });
  }

  updateVariantStatuses() {
    if (!this.variantData) {
      this.getVariantData();
    }

    const checkedInput =
      this.querySelector(":checked");

    if (!checkedInput) return;

    const selectedOptionOneVariants =
      this.variantData.filter(
        (variant) =>
          checkedInput.value === variant.option1
      );

    const inputWrappers = [
      ...this.querySelectorAll(".product-form__input"),
    ];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const optionInputs = [
        ...option.querySelectorAll(
          'input[type="radio"], option'
        ),
      ];

      const previousChecked =
        inputWrappers[index - 1]?.querySelector(
          ":checked"
        );

      if (!previousChecked) return;

      const previousOptionSelected =
        previousChecked.value;

      const availableOptionInputsValue =
        selectedOptionOneVariants
          .filter(
            (variant) =>
              this.isVariantSellable(variant) &&
              variant[`option${index}`] ===
                previousOptionSelected
          )
          .map(
            (variantOption) =>
              variantOption[`option${index + 1}`]
          );

      this.setInputAvailability(
        optionInputs,
        availableOptionInputsValue
      );
    });
  }

  setInputAvailability(
    listOfOptions,
    listOfAvailableOptions
  ) {
    listOfOptions.forEach((input) => {
      if (
        listOfAvailableOptions.includes(
          input.getAttribute("value")
        )
      ) {
        input.innerText =
          input.getAttribute("value");
      } else {
        input.innerText =
          window.variantStrings.unavailable_with_option.replace(
            "[value]",
            input.getAttribute("value")
          );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability =
      document.querySelector(
        "pickup-availability"
      );

    if (!pickUpAvailability) return;

    const state = this.getPurchaseState();

    if (
      this.currentVariant &&
      !state.soldOut
    ) {
      if (
        typeof pickUpAvailability.fetchAvailability ===
        "function"
      ) {
        pickUpAvailability.fetchAvailability(
          this.currentVariant.id
        );
      }
    } else {
      pickUpAvailability.removeAttribute(
        "available"
      );

      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    if (!this.currentVariant) return;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id =
          `price-${this.dataset.section}`;

        const stockInventory =
          `inventory__stock--${this.dataset.section}`;

        const barcodeId =
          `barcode__${this.dataset.section}`;

        const skuId =
          `sku__${this.dataset.section}`;

        const html =
          new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

        const destination =
          document.getElementById(id);

        const stockInventoryDestination =
          document.getElementById(
            stockInventory
          );

        const barcodeDestination =
          document.getElementById(
            barcodeId
          );

        const skuDestination =
          document.getElementById(skuId);

        const source =
          html.getElementById(id);

        const stockInventorySource =
          html.getElementById(
            stockInventory
          );

        const barcodeSource =
          html.getElementById(barcodeId);

        const skuSource =
          html.getElementById(skuId);

        if (source && destination) {
          destination.innerHTML =
            source.innerHTML;
        }

        if (
          stockInventorySource &&
          stockInventoryDestination
        ) {
          stockInventoryDestination.innerHTML =
            stockInventorySource.innerHTML;
        }

        if (
          barcodeSource &&
          barcodeDestination
        ) {
          barcodeDestination.innerHTML =
            barcodeSource.innerHTML;
        }

        if (skuSource && skuDestination) {
          skuDestination.innerHTML =
            skuSource.innerHTML;
        }

        const price =
          document.getElementById(
            `price-${this.dataset.section}`
          );

        if (price) {
          price.classList.remove(
            "no-js-inline"
          );
        }

        /*
         * IMPORTANT:
         * Server HTML load hone ke baad dobara
         * real qty + inventory policy check.
         */
        this.updatePurchaseState();
      })
      .catch((error) => {
        console.error(
          "Variant render error:",
          error
        );

        this.updatePurchaseState();
      });
  }

  /*
   * =========================================================
   * NEW INVENTORY LOGIC
   * =========================================================
   */

  getInventoryRecord(variant = this.currentVariant) {
    if (!variant) return null;

    this.getPreOrderVariantData();

    if (!this.PreorderVariantData) {
      return null;
    }

    return (
      this.PreorderVariantData[variant.id] ||
      this.PreorderVariantData[
        String(variant.id)
      ] ||
      null
    );
  }

  getPurchaseState(
    variant = this.currentVariant
  ) {
    if (!variant) {
      return {
        soldOut: true,
        preorder: false,
        available: false,
        quantity: 0,
        policy: "deny",
        hasInventoryData: false,
      };
    }

    const inventory =
      this.getInventoryRecord(variant);

    /*
     * Agar theme ke preorder/inventory JSON me
     * actual qty aur policy available hain,
     * unko Shopify variant.available se priority milegi.
     */
    if (
      inventory &&
      inventory.qty !== undefined &&
      inventory.qty !== null
    ) {
      const quantity =
        Number.parseInt(
          inventory.qty,
          10
        );

      const safeQuantity =
        Number.isNaN(quantity)
          ? 0
          : quantity;

      const policy =
        inventory.inventory_policy ||
        "deny";

      const soldOut =
        safeQuantity <= 0 &&
        policy !== "continue";

      const preorder =
        safeQuantity <= 0 &&
        policy === "continue" &&
        Boolean(window.preorder_button);

      return {
        soldOut,
        preorder,
        available: !soldOut,
        quantity: safeQuantity,
        policy,
        hasInventoryData: true,
      };
    }

    /*
     * Fallback:
     * Inventory JSON missing ho to Shopify's
     * normal available property use hogi.
     */
    return {
      soldOut: !variant.available,
      preorder: false,
      available: Boolean(
        variant.available
      ),
      quantity: null,
      policy: null,
      hasInventoryData: false,
    };
  }

  isVariantSellable(variant) {
    return this.getPurchaseState(
      variant
    ).available;
  }

  updatePurchaseState() {
    if (!this.currentVariant) {
      this.toggleAddButton(
        true,
        window.variantStrings?.unavailable ||
          "UNAVAILABLE"
      );

      this.toggleDynamicCheckout(false);

      return;
    }

    const state =
      this.getPurchaseState();

    if (state.soldOut) {
      this.toggleAddButton(
        true,
        window.variantStrings?.soldOut ||
          "OUT OF STOCK"
      );

      this.toggleDynamicCheckout(false);

      return;
    }

    if (state.preorder) {
      this.toggleAddButton(
        false,
        window.variantStrings?.preorder ||
          "PRE ORDER"
      );

      this.toggleDynamicCheckout(true);

      return;
    }

    this.toggleAddButton(
      false,
      window.variantStrings?.addToCart ||
        "ADD TO CART"
    );

    this.toggleDynamicCheckout(true);
  }

  toggleAddButton(
    disable = true,
    text = "",
    modifyClass = true
  ) {
    const productForm =
      document.getElementById(
        `product-form-${this.dataset.section}`
      );

    if (!productForm) return;

    const addButton =
      productForm.querySelector(
        '[name="add"]'
      );

    if (!addButton) return;

    const addButtonText =
      addButton.querySelector(
        ".cart--button-text"
      );

    if (disable) {
      addButton.setAttribute(
        "disabled",
        "disabled"
      );

      addButton.setAttribute(
        "aria-disabled",
        "true"
      );
    } else {
      addButton.removeAttribute(
        "disabled"
      );

      addButton.removeAttribute(
        "aria-disabled"
      );
    }

    if (text) {
      if (addButtonText) {
        addButtonText.textContent = text;
      } else {
        addButton.textContent = text;
      }
    }

    if (!modifyClass) return;
  }

  toggleDynamicCheckout(show) {
    const productForm =
      document.getElementById(
        `product-form-${this.dataset.section}`
      );

    if (!productForm) return;

    const paymentButton =
      productForm.querySelector(
        ".shopify-payment-button"
      );

    if (!paymentButton) return;

    paymentButton.style.display =
      show ? "" : "none";
  }

  setUnavailable() {
    const productForm =
      document.getElementById(
        `product-form-${this.dataset.section}`
      );

    if (!productForm) return;

    const addButton =
      productForm.querySelector(
        '[name="add"]'
      );

    const price =
      document.getElementById(
        `price-${this.dataset.section}`
      );

    if (!addButton) return;

    addButton.setAttribute(
      "disabled",
      "disabled"
    );

    addButton.setAttribute(
      "aria-disabled",
      "true"
    );

    const addButtonText =
      addButton.querySelector(
        ".cart--button-text"
      );

    if (addButtonText) {
      addButtonText.textContent =
        window.variantStrings
          ?.unavailable ||
        "UNAVAILABLE";
    } else {
      addButton.textContent =
        window.variantStrings
          ?.unavailable ||
        "UNAVAILABLE";
    }

    this.toggleDynamicCheckout(false);

    if (price) {
      price.classList.add(
        "no-js-inline"
      );
    }
  }

  getVariantData() {
    if (this.variantData) {
      return this.variantData;
    }

    const variantElement =
      this.querySelector(
        "[data-variant]"
      );

    if (!variantElement) {
      this.variantData = [];
      return this.variantData;
    }

    try {
      this.variantData =
        JSON.parse(
          variantElement.textContent
        );
    } catch (error) {
      console.error(
        "Variant JSON error:",
        error
      );

      this.variantData = [];
    }

    return this.variantData;
  }

  getPreOrderVariantData() {
    if (this.PreorderVariantData) {
      return this.PreorderVariantData;
    }

    const preorderElement =
      this.querySelector(
        "[data-preorder]"
      );

    if (!preorderElement) {
      this.PreorderVariantData = {};
      return this.PreorderVariantData;
    }

    try {
      this.PreorderVariantData =
        JSON.parse(
          preorderElement.textContent
        );
    } catch (error) {
      console.error(
        "Inventory JSON error:",
        error
      );

      this.PreorderVariantData = {};
    }

    return this.PreorderVariantData;
  }
}

if (
  !customElements.get(
    "variant-selects"
  )
) {
  customElements.define(
    "variant-selects",
    VariantSelects
  );
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.fieldsets = Array.from(
      this.querySelectorAll(
        "fieldset"
      )
    );

    this.onColorSwatches();
  }

  onColorSwatches() {
    const variantList =
      this.getVariantData() || [];

    const swatchButtonList =
      this.querySelectorAll(
        `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
      );

    const result =
      Object.values(
        variantList.reduce(
          (total, item) => {
            const key =
              `${item[this.dataset.colorSwatch]}`;

            if (!total[key]) {
              total[key] = {
                ...item,
                count: 1,
              };
            } else {
              total[key].count += 1;
            }

            return total;
          },
          {}
        )
      );

    if (
      swatchButtonList.length > 0
    ) {
      swatchButtonList.forEach(
        (button) => {
          result.forEach((data) => {
            if (
              data[
                this.dataset.colorSwatch
              ] ===
              button.dataset.value
            ) {
              if (
                this.dataset
                  .colorSwatchStyle ===
                  "image" &&
                data.featured_image !==
                  null
              ) {
                button.setAttribute(
                  "style",
                  `--swatch-background-image: url(${data.featured_image.src}); --swatch-background-color: ${data[this.dataset.colorSwatch]};`
                );
              } else {
                button.setAttribute(
                  "style",
                  `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
                );
              }
            }
          });
        }
      );
    }
  }

  setInputAvailability(
    listOfOptions,
    listOfAvailableOptions
  ) {
    listOfOptions.forEach(
      (input) => {
        if (
          listOfAvailableOptions.includes(
            input.getAttribute(
              "value"
            )
          )
        ) {
          input.classList.remove(
            "disabled"
          );
        } else {
          input.classList.add(
            "disabled"
          );
        }
      }
    );
  }

  updateOptions() {
    const fieldsets =
      Array.from(
        this.querySelectorAll(
          "fieldset"
        )
      );

    this.options =
      fieldsets.map((fieldset) => {
        const selected =
          Array.from(
            fieldset.querySelectorAll(
              "input"
            )
          ).find(
            (radio) =>
              radio.checked
          );

        return selected
          ? selected.value
          : null;
      });
  }

  updateOptionsParent() {
    if (!this.fieldsets) {
      this.fieldsets =
        Array.from(
          this.querySelectorAll(
            "fieldset"
          )
        );
    }

    this.fieldsets.forEach(
      (fieldset, index) => {
        if (
          fieldset.children[0] &&
          fieldset.children[0]
            .children[1]
        ) {
          fieldset.children[0]
            .children[1].innerHTML =
            this.options[index] || "";
        }
      }
    );
  }
}

if (
  !customElements.get(
    "variant-radios"
  )
) {
  customElements.define(
    "variant-radios",
    VariantRadios
  );
}